import {Brick, registerBrick} from 'olympe';

/**
 *
 */
export default class ClearLocalStorage extends Brick {
    /**
     * Executed every time the brick receives a new trigger event.
     * Note that the method will be executed _even if_ an input () is undefined.
     *
     * @protected
     * @param {BrickContext} context
     * @param {!Array} inputs
     * @param {function()} forwardEvent
     */
    onUpdate(context, inputs, [forwardEvent]) {
    // Making sure the browser support local storage
        if (typeof Storage !== 'undefined') {
            localStorage.clear();
            forwardEvent();
        } else {
            throw new Error(`Your browser does not support the window.localStorage API`);
        }
    }
}

registerBrick('017af16a3634a93ec06f', ClearLocalStorage);
